/** Every tool id, in the hub's display order. Frozen to prevent mutation. */
export const ALL_TOOL_IDS = Object.freeze([
    'pick',
    'xfer',
    'adj',
    'pur',
    'audit',
    'find',
]);
const TOOL_ID_SET = new Set(ALL_TOOL_IDS);
/** Runtime type guard: true when `x` is one of the known {@link ToolId} values. */
export function isToolId(x) {
    return typeof x === 'string' && TOOL_ID_SET.has(x);
}
//# sourceMappingURL=tool-ids.js.map